
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      toLink: this.$route.meta.toAppointment,
    };
  },
});
